import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceTaskStatusCreationNotificationState = createStateReducer(
  initialState,
  {
    [events.createTaskStatusSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createTaskStatus",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createTaskStatusFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createTaskStatus",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceTaskStatusCreationNotificationState };
